import React from 'react';
import cn from 'classnames';
import keycode from 'keycode';
import { Icon } from '@economic/gaudi';

import GlobalKeyboardShortcuts from '../../../shared/components/GlobalKeyboardShortcuts';
import Mutation from '../../../shared/components/Mutation';
import Agreement from './Agreement';
import { AgreementSelector } from './Selector';
import { setToastPosition, resetToastPosition } from '../../../shared/util/utilities/toastPosition';
import './style.css';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    currentAgreement: any;
    otherAgreements: any[];
    refetchAgreements: Function;
    user: any;
}

interface State {
    isOpen: boolean;
    toggleAllowed: boolean;
}

export default class AgreementDetails extends React.Component<Props, State> {
    state = { isOpen: false, toggleAllowed: true };
    node: React.RefObject<any> = React.createRef();
    selectorRef: React.RefObject<HTMLDivElement> = React.createRef();

    componentWillUnmount() {
        window.removeEventListener('click', this.onClickOutside);
        window.firebird.removeEventListener('click', this.onClickOutside);
    }

    render() {
        const { currentAgreement, otherAgreements = [], refetchAgreements, user } = this.props;
        const { isOpen } = this.state;

        const className = cn('relative bg-purple-dark flex items-center', this.props.className);

        if (user.vismaId || user.isAdministrator) {
            return (
                <GlobalKeyboardShortcuts handlers={{ ',': this.toggle }}>
                    <aside id="agreement_details" className={className} ref={this.node}>
                        <Agreement
                            isAdministrator={user.isAdministrator}
                            isDeveloper={currentAgreement.isDeveloper}
                            name={currentAgreement.name}
                            number={currentAgreement.number}
                            onClick={this.toggle}
                            onKeyDown={this.onKeyDown}
                            userId={user.id}>
                            <Icon name={isOpen ? 'chevron-up' : 'chevron-down'} className="text-white pointer-events-none" />
                        </Agreement>
                        {isOpen && (
                            <Mutation url="/agreementselector/switch">
                                {({ mutate }) => (
                                    <AgreementSelector
                                        ref={this.selectorRef}
                                        agreements={otherAgreements}
                                        onChangeAgreement={this.changeAgreement(mutate)}
                                        refetchAgreements={refetchAgreements}
                                        onToggleAllowedChange={(allowed: boolean) => this.setState({ toggleAllowed: allowed })}
                                    />
                                )}
                            </Mutation>
                        )}
                    </aside>
                </GlobalKeyboardShortcuts>
            );
        }

        return (
            <aside id="agreement_details" className={className}>
                <Agreement
                    isDeveloper={currentAgreement.isDeveloper}
                    name={currentAgreement.name}
                    number={currentAgreement.number}
                    userId={user.id}
                />
            </aside>
        );
    }

    onClickOutside = (e: { target: any }) => {
        if (this.node.current && !this.node.current.contains(e.target)) {
            this.toggle();
        }
    };

    onKeyDown = (event: { keyCode: number }) => {
        if (event.keyCode === keycode('space') || event.keyCode === keycode('enter')) {
            this.toggle();
        }
    };

    toggle = () => {
        if (this.state.toggleAllowed === false) return;
        this.setState(
            state => ({ ...this.state, isOpen: !state.isOpen }),
            () => {
                if (this.state.isOpen) {
                    window.addEventListener('click', this.onClickOutside);
                    window.firebird.addEventListener('click', this.onClickOutside);
                    setToastPosition(this.selectorRef.current);
                } else {
                    window.removeEventListener('click', this.onClickOutside);
                    window.firebird.removeEventListener('click', this.onClickOutside);
                    resetToastPosition();
                }
            }
        );
    };
    changeAgreement = (mutate: (arg0: any) => Promise<any>) => (agreement: any) => {
        mutate(agreement).then(response => {
            if (response && response.data.redirectUrl) {
                window.location.href = response.data.redirectUrl;
            } else {
                window.location.href = window.location.origin;
            }
        });
    };
}
